import React from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import { isMobileOnly } from "react-device-detect"

const query = graphql`
  {
    fotka: file(relativePath: { eq: "img1.jpg" }) {
      childImageSharp {
        fluid(quality: 60) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

const SideLadowarki = () => {
  const data = useStaticQuery(query)


  return (
    <BackgroundImage
      Tag="section"
      className={`col-12 col-lg-6 side-1`}
      fluid={data.fotka.childImageSharp.fluid}
      backgroundColor={`#000`}
    >
      <div className="bg-overlay"></div>
      <div
        data-sal={!isMobileOnly ? "slide-up" : ""}
        data-sal-delay="500"
        data-sal-duration="600"
        data-sal-easing="ease"
        className="box p-3 p-md-5 ie11animfix"
      >
        <Link to="ladowarki" title="Poznaj nasze ładowarki">
          <div className="box-title">NASZE ŁADOWARKI</div>
          <p className="mb-3">
            <span>
              W sieci ORLEN kierowcy pojazdów elektrycznych mogą korzystać
              z&nbsp;trzech modeli ładowarek: Ekoenergetyka, ABB oraz Efacec.
              <strong>
                Wszystkie ładowarki są wyposażone w&nbsp;3 różne rodzaje złącz
              </strong>
              : dwa złącza DC (CCS i CHAdeMO) oraz&nbsp;jedno AC (Typ 2).
              Większość naszych ładowarek znajduje się przy stacjach paliw
              ORLEN.
            </span>
          </p>
          <span className="link-more">Poznaj nasze ładowarki</span>
        </Link>
      </div>
    </BackgroundImage>
  )
}


export default SideLadowarki

